export default __webpack_public_path__ + "static/media/livio.3dec85f6.svg";